import { useRouter, useTranslations } from "@packages/i18n";
import { useLocalStorageState } from "@packages/sdk";
import {
  Button,
  ChevronDownIcon,
  ModalDropdownMenu,
  ModalDropdownMenuItem,
} from "@packages/ui";

type BibleLinkProps = {
  variant: "bible" | "daily-readings";
};

export const BibleLink = ({ variant }: BibleLinkProps) => {
  const router = useRouter();
  const t = useTranslations();
  const [, setCategory] = useLocalStorageState({
    key: "bibleCategory",
    defaultValue: variant,
  });

  const redirect = (newVariant: "bible" | "daily-readings") => {
    setCategory(newVariant);
    // trust the localStorage category above to get us to the right place
    router.push("/bible");
  };

  return (
    <ModalDropdownMenu
      trigger={
        <Button variant={"outline"} endIcon={<ChevronDownIcon />}>
          {t(variant === "bible" ? "bible_title" : "daily_readings_title")}
        </Button>
      }
      dropdownMenuProps={{ align: "center" }}
    >
      <ModalDropdownMenuItem
        key={"goToBible"}
        selected={variant === "bible"}
        onSelect={() => redirect("bible")}
      >
        {t("bible_title")}
      </ModalDropdownMenuItem>
      <ModalDropdownMenuItem
        key={"goToDailyReadings"}
        selected={variant === "daily-readings"}
        onSelect={() => redirect("daily-readings")}
      >
        {t("daily_readings_title")}
      </ModalDropdownMenuItem>
    </ModalDropdownMenu>
  );
};
